var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoNotification = function SvgNoNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.013,
    height: 94,
    viewBox: "0 0 94.013 94"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6037",
    "data-name": "Group 6037",
    transform: "translate(-288 -37.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6035",
    "data-name": "Group 6035",
    transform: "translate(288 37.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5642",
    "data-name": "Path 5642",
    d: "M377.151,131.093H292.863A4.876,4.876,0,0,1,288,126.214V63.345l44.591-25.62a4.93,4.93,0,0,1,4.83,0l44.591,25.62v62.869A4.876,4.876,0,0,1,377.151,131.093ZM291.242,65.221v60.994a1.63,1.63,0,0,0,1.621,1.637h84.288a1.63,1.63,0,0,0,1.621-1.637V65.221L335.807,40.537a1.629,1.629,0,0,0-1.6,0Z",
    transform: "translate(-288 -37.093)",
    fill: "#ececec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6036",
    "data-name": "Group 6036",
    transform: "translate(288.682 63.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5643",
    "data-name": "Path 5643",
    d: "M334.745,87.009a8.117,8.117,0,0,1-4.707-1.5l-41.617-29.6,1.877-2.64,41.617,29.595a4.888,4.888,0,0,0,5.66,0l41.617-29.595,1.877,2.64-41.617,29.6A8.116,8.116,0,0,1,334.745,87.009Z",
    transform: "translate(-288.421 -53.271)",
    fill: "#ececec"
  })))));
};
export default SvgNoNotification;